module.exports = __webpack_public_path__ + "static/img/top1.8b1c9190.png";